import { Leaf, Wheat, Wine } from "lucide-react";
import { Reveal } from "./Reveal";

const BANQUET_IMG =
  "https://images.pexels.com/photos/10970549/pexels-photo-10970549.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const STATS = [
  { value: "300+", label: "Events staged" },
  { value: "48k", label: "Guests served" },
  { value: "11", label: "Courses, longest menu" },
];

export const Bento = () => (
  <section id="philosophy" data-testid="bento-specialties-section" className="bg-bone py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-16">
        <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-ink-mute">
          Philosophy & Craft
        </p>
        <h2 className="max-w-2xl font-serif text-3xl leading-tight tracking-tight text-noir sm:text-4xl lg:text-5xl">
          Precision you can <span className="italic text-truffle">taste</span>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-4">
        <Reveal className="md:col-span-2 md:row-span-2">
          <div
            data-testid="bento-philosophy-card"
            className="flex h-full min-h-[320px] flex-col justify-between rounded-3xl bg-noir p-8 text-bone sm:p-10"
          >
            <Leaf size={26} className="text-gold" />
            <div>
              <h3 className="font-serif text-2xl leading-snug sm:text-3xl">
                "A plate should read like a floor plan — every element placed
                with intent, nothing decorative without purpose."
              </h3>
              <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.25em] text-bone/50">
                Kasey Beaumont — Founding Chef
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div
            data-testid="bento-sourcing-card"
            className="flex h-full min-h-[180px] flex-col justify-between rounded-3xl border border-noir/10 bg-white p-7 transition-[border-color,box-shadow] duration-500 hover:border-gold/50 hover:shadow-[0_20px_40px_-20px_rgba(92,64,51,0.25)]"
          >
            <span className="font-serif text-5xl text-truffle">92%</span>
            <p className="mt-4 text-sm leading-relaxed text-ink-soft">
              of produce sourced farm-direct within 100 miles, traced to the grower
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.18} className="md:row-span-2">
          <div
            data-testid="bento-wine-card"
            className="group relative h-full min-h-[380px] overflow-hidden rounded-3xl"
          >
            <img
              src={BANQUET_IMG}
              alt="Sommelier pouring wine at an elegant fine dining banquet setting"
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.05]"
            />
            <div className="absolute inset-0 bg-noir/35" />
            <div className="absolute inset-x-0 bottom-0 p-7">
              <Wine size={22} className="mb-3 text-gold" />
              <h3 className="font-serif text-2xl text-bone">Sommelier Pairings</h3>
              <p className="mt-2 text-sm leading-relaxed text-bone/80">
                A cellar-led pairing flight composed for every menu
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.26}>
          <div
            data-testid="bento-dietary-card"
            className="flex h-full min-h-[180px] flex-col justify-between rounded-3xl border border-noir/10 bg-white p-7 transition-[border-color,box-shadow] duration-500 hover:border-gold/50 hover:shadow-[0_20px_40px_-20px_rgba(92,64,51,0.25)]"
          >
            <Wheat size={24} className="text-gold" />
            <p className="mt-4 text-sm leading-relaxed text-ink-soft">
              <span className="font-medium text-noir">Dietary artistry</span> — vegan,
              gluten-free and allergen menus built from scratch, never substituted
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.34} className="md:col-span-4">
          <div
            data-testid="bento-capacity-card"
            className="grid grid-cols-1 divide-y divide-noir/10 rounded-3xl border border-noir/10 bg-linen sm:grid-cols-3 sm:divide-x sm:divide-y-0"
          >
            {STATS.map((s) => (
              <div key={s.label} className="flex items-baseline justify-between gap-4 px-8 py-7 sm:flex-col sm:items-start sm:gap-2">
                <span className="font-serif text-4xl text-noir sm:text-5xl">{s.value}</span>
                <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-mute">
                  {s.label}
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
